module.exports = __webpack_public_path__ + "Flag-586.98eef34fe655c33fdadcbf5939a16a38.svg";